import { remove } from '@/helpers/httpHandler';
export default {
  data() {
    return {
      toBeRemovedIds: []
    };
  },

  methods: {
    sendDestroyRequest(id, url = '/uploads') {
      remove(`${url}/${id}`).catch(({ response }) => {
        console.log(response);
      });
    },

    filterToBeRemovedIds(arr) {
      this.toBeRemovedIds = this.toBeRemovedIds.filter(
        item => !arr.includes(item.id)
      );
    },

    addToBeRemoved(item) {
      this.toBeRemovedIds.push(item);
    },

    removeUnnecessaryFiles(filesArray = [...this.toBeRemovedIds]) {
      if (filesArray && filesArray.length > 0) {
        filesArray.forEach(item => {
          if (item.id) {
            this.sendDestroyRequest(item.id);
          }
        });
        this.toBeRemovedIds = [];
      }
    }
  }
};
